import {Component, forwardRef, HostBinding, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-input-checkbox',
    templateUrl: './input-checkbox.component.html',
    styleUrl: './input-checkbox.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputCheckboxComponent),
            multi: true,
        },
    ],
})
export class InputCheckboxComponent implements ControlValueAccessor, OnChanges {

    @Input() name: string;


    @HostBinding('class.has-value') public value: boolean;

    @Input('disabled') isDisabledInput: boolean | number | '';
    @HostBinding('class.disabled') isDisabled: boolean;

    @HostBinding('class.active') isActive: boolean;

    public propagateChange: (_: any) => void = (_: any) => {
    };

    public onTouched: () => void = () => {
        // console.log('onTouched');
    };

    public registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(value: boolean): void {
        this.value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    onBlur() {
        this.onTouched();
        this.isActive = false;
    }

    onFocus() {
        this.isActive = true;
    }

    onNgModelChanged() {
        this.propagateChange(this.value);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.isDisabledInput !== '') {
            // set via angular [disabled] attribute
            this.isDisabled = !!this.isDisabledInput;
        } else {
            // set via attribute disabled only
            this.isDisabled = true;
        }
    }

}
